import { render, staticRenderFns } from "./OrderGroupEdit.vue?vue&type=template&id=d3726030&scoped=true"
import script from "./OrderGroupEdit.vue?vue&type=script&lang=js"
export * from "./OrderGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3726030",
  null
  
)

export default component.exports